import React, {useEffect, useState} from 'react'
import { useSelector } from 'react-redux';
import TitleLink from '../../components/TitleLink';
import { useTranslation } from 'react-i18next';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import styled from '@emotion/styled';

const TableRowStyled = styled(TableRow)`
  &:nth-of-type(odd) {
    background-color: #1976d214;
  }
  &:nth-of-type(even) {
    background-color: white;
  }
  & > td {
    color: black;
  }
`;

function Profile() {
    const {t} = useTranslation('global');
    const [user, setUser] = useState()
   
    const clinicalUser = JSON.parse(localStorage.getItem("userInfo"));

   
    useEffect(()=>{
        setUser(clinicalUser);
    },[])

console.log('users ::: ', user)

  return (
    <div className='full-container'>
         <TitleLink
            boxTitle={t('profile')}
        />
        <div style={{width:'60%', display:'flex', justifyContent:'center'}}>
            <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
               
                </TableHead>
                <TableBody>
                    <TableRowStyled>
                        <TableCell sx={{fontWeight:'bold'}}>{t('userType')}</TableCell>
                        <TableCell align="left">{user?.userType}</TableCell>
                    </TableRowStyled>
                    <TableRowStyled>
                        <TableCell sx={{fontWeight:'bold'}}>{t('userName')}</TableCell>
                        <TableCell align="left">{user?.firstName}</TableCell>
                    </TableRowStyled>
                    <TableRowStyled>
                        <TableCell sx={{fontWeight:'bold'}}>{t('lastName')}</TableCell>
                        <TableCell align="left">{user?.lastName}</TableCell>
                    </TableRowStyled>
                    <TableRowStyled>
                        <TableCell sx={{fontWeight:'bold'}}>{t('phone_number')}</TableCell>
                        <TableCell align="left">{user?.phone}</TableCell>
                    </TableRowStyled>
                    <TableRowStyled>
                        <TableCell sx={{fontWeight:'bold'}}>{t('email')}</TableCell>
                        <TableCell align="left">{user?.email}</TableCell>
                    </TableRowStyled>
                </TableBody>
               
            </Table>
            </TableContainer>
        </div>
    </div>
  )
}

export default Profile